import { render, staticRenderFns } from "./breadcrumbs.vue?vue&type=template&id=5a95871c&scoped=true&"
import script from "./breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./breadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./breadcrumbs.vue?vue&type=style&index=0&id=5a95871c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a95871c",
  null
  
)

export default component.exports